export interface SalesPartnerModel {
  id: number;
  name: string;
  contactNo: string;
  isActive: boolean;
  referralCode?: string;
  createdDateTime?: string;
  isDeleted?: boolean;
}

export const SalesPartnerModelObject: SalesPartnerModel = {
  id: 0,
  name: '',
  contactNo: '',
  isActive: true
};
